import interact from 'interactjs'

export default {
  bind(el, binding) {
    const options = {
      edges: {
        top: binding.value?.edges?.top ?? true,
        left: binding.value?.edges?.left ?? true,
        bottom: binding.value?.edges?.bottom ?? true,
        right: binding.value?.edges?.right ?? true,
      },
      minWidth: binding.value?.minWidth ?? 400,
      minHeight: binding.value?.minHeight ?? 300,
      onResize: binding.value?.onResize,
      ...binding.value
    }

    const dialog = el.querySelector('.el-dialog')
    if (!dialog) return
    const initialWidth = parseInt(window.getComputedStyle(dialog).width)
    const initialHeight = parseInt(window.getComputedStyle(dialog).height)
    let isManuallyResized = false
    const centerDialog = () => {
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      const dialogWidth = parseInt(dialog.style.width || initialWidth)
      const dialogHeight = parseInt(dialog.style.height || initialHeight)
      const x = (windowWidth - dialogWidth) / 2
      const y = Math.max(20, (windowHeight - dialogHeight) / 2)
      dialog.style.position = 'fixed'
      dialog.style.left = `${x}px`
      dialog.style.top = `${y}px`
      dialog.style.margin = '0'
      dialog.setAttribute('data-x', x)
      dialog.setAttribute('data-y', y)
    }
    centerDialog()
    window.addEventListener('resize', centerDialog)
    el._centerDialog = centerDialog
    interact(dialog).draggable({
      allowFrom: '.el-dialog__header',
      listeners: {
        move(event) {
          const x = (parseFloat(dialog.getAttribute('data-x')) || 0) + event.dx
          const y = (parseFloat(dialog.getAttribute('data-y')) || 0) + event.dy

          dialog.style.left = `${x}px`
          dialog.style.top = `${y}px`
          dialog.setAttribute('data-x', x)
          dialog.setAttribute('data-y', y)
        }
      }
    })
    interact(dialog).resizable({
      edges: options.edges,
      listeners: {
        start: () => {
          isManuallyResized = true
        },
        move: (event) => {
          let { width, height } = event.rect
          width = Math.max(options.minWidth, width)
          height = Math.max(options.minHeight, height)
          const maxHeight = binding.value?.maxHeight ?? 800;
          if (height > maxHeight) height = maxHeight;

          let x = parseFloat(dialog.getAttribute('data-x')) || 0
          let y = parseFloat(dialog.getAttribute('data-y')) || 0

          // 处理左边缘拖动
          if (event.edges.left) {
            const dx = event.deltaRect.left
            x += dx
            dialog.style.left = `${x}px`
            dialog.setAttribute('data-x', x)
          }

          // 只在单独拖动上边时调整 top
          if (event.edges.top && !(event.edges.left || event.edges.right)) {
            const dy = event.deltaRect.top
            y += dy
            dialog.style.top = `${y}px`
            dialog.setAttribute('data-y', y)
          }

          // 只在左右拖动时设置宽度
          if (event.edges.left || event.edges.right) {
            dialog.style.width = `${width}px`
          }

          // 只在上下拖动时设置高度，并限制最大高度
          if (event.edges.top || event.edges.bottom) {
            dialog.style.height = `${height}px`
          }

          const body = dialog.querySelector('.el-dialog__body')
          if (body) {
            const headerHeight = dialog.querySelector('.el-dialog__header')?.offsetHeight || 50
            const footerHeight = dialog.querySelector('.el-dialog__footer')?.offsetHeight || 60
            // body.style.height = `calc(100% - ${headerHeight + footerHeight - 50}px)`
            body.style.overflow = 'auto'
          }

          if (typeof options.onResize === 'function' && isManuallyResized) {
            options.onResize({
              width,
              height,
              originalWidth: initialWidth,
              originalHeight: initialHeight,
              scaleX: width / initialWidth,
              scaleY: height / initialHeight,
              isManual: true
            })
          }
        },
        end: () => {
        }
      },
      modifiers: [
        interact.modifiers.restrictSize({
          min: { width: options.minWidth, height: options.minHeight }
        })
      ]
    })
    const style = document.createElement('style')
    style.textContent = `

      .el-dialog.is-resizable::after {
        content: '';
        position: absolute;
        right: 2px;
        bottom: 2px;
        width: 12px;
        height: 12px;
        background: linear-gradient(135deg, transparent 45%, #909399 45%, #909399 55%, transparent 55%);
        cursor: se-resize;
        z-index: 100;
      }
      .el-dialog.is-resizable .el-dialog__header {
        cursor: move;
      }`
    document.head.appendChild(style)
    dialog.classList.add('is-resizable')
  },
  unbind(el) {
    window.removeEventListener('resize', el._centerDialog)
    interact('.el-dialog').unset()
  }
}